export const SOUNDS = [
  {
    name: "mario_nes_snes_sounds/1up.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/1up.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Break Brick.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Break Brick.mp3")
  },
  {
    name: "mario_nes_snes_sounds/coin (nes).mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/coin (nes).mp3")
  },
  {
    name: "mario_nes_snes_sounds/coin (snes).mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/coin (snes).mp3")
  },
  {
    name: "mario_nes_snes_sounds/emerge (nes).mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/emerge (nes).mp3")
  },
  {
    name: "mario_nes_snes_sounds/emerge (snes).mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/emerge (snes).mp3")
  },
  {
    name: "mario_nes_snes_sounds/fireball.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/fireball.mp3")
  },
  {
    name: "mario_nes_snes_sounds/hit block (nes).mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/hit block (nes).mp3")
  },
  {
    name: "mario_nes_snes_sounds/hit block (snes).mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/hit block (snes).mp3")
  },
  {
    name: "mario_nes_snes_sounds/Invincibility Music.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Invincibility Music.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - Cannon.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - Cannon.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - Die.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - Die.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - Game Over.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - Game Over.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - GameOver 2.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - GameOver 2.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - Jump.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - Jump.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - Mario Riff.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - Mario Riff.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - Win 2.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - Win 2.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - Win Stage.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - Win Stage.mp3")
  },
  {
    name: "mario_nes_snes_sounds/Mario 1 - Win.mp3",
    path: require("../assets/sounds/mario_nes_snes_sounds/Mario 1 - Win.mp3")
  },
//{
//  name: "mario_nes_snes_sounds/Mario 2 - damage (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - damage (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 2 - Die.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - Die.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 2 - Door.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - Door.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 2 - Game Over.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - Game Over.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 2 - jump.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 2 - jump.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 2 - Pick Up (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - Pick Up (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 2 - Select character.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - Select character.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 2 - Throw.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - Throw.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 2 - win level.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - win level.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 2 - win lives.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 2 - win lives.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - battle victory.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - battle victory.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - beat final boss.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - beat final boss.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - Die (nes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - Die (nes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - Die (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - Die (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - Door.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - Door.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - dry_bones.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - dry_bones.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - enter stage.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - enter stage.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - Explosion (nes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - Explosion (nes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - Explosion (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - Explosion (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - flame.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - flame.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - Game Over.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - Game Over.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - get item.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - get item.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - jump (nes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - jump (nes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - jump (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - jump (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - koopaKid spin.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - koopaKid spin.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - level complete.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - level complete.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - mapMove.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - mapMove.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - power up (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - power up (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - Power Up.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - Power Up.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - reveal item (rough).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - reveal item (rough).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - skid (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - skid (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - sprint.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - sprint.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - tail.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - tail.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - thwomp.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - thwomp.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - vanish (nes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - vanish (nes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/mario 3 - vanish (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/mario 3 - vanish (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario 3 - whistle.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario 3 - whistle.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario World - 1up.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario World - 1up.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario World - Jump (reverb).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario World - Jump (reverb).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Mario World - SpringBoard.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Mario World - SpringBoard.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/pause (nes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/pause (nes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/pause (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/pause (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Pipe.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Pipe.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Power Up (nes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Power Up (nes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/Power Up (snes).mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/Power Up (snes).mp3")
//},
//{
//  name: "mario_nes_snes_sounds/saveGame.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/saveGame.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/shell kick.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/shell kick.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/stomp.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/stomp.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/time's running out.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/time's running out.mp3")
//},
//{
//  name: "mario_nes_snes_sounds/vine emerge.mp3",
//  path: require("../assets/sounds/mario_nes_snes_sounds/vine emerge.mp3")
//}
];

